import { View, Image, Button } from "@/components/ui";
import { getPlatform } from "@/lib/utils";

export type QrProps = {
  paymentQrUri: string;
  onDownloadQr: () => void;
  downloadDisabled?: boolean;
};

export const Qr = ({
  paymentQrUri,
  onDownloadQr,
  downloadDisabled = false,
}: QrProps) => (
  <View className="flex flex-col items-center gap-2">
    <View className="h-[250px] w-[250px]">
      <Image
        className="h-full w-full"
        src={paymentQrUri}
        {...(getPlatform() !== "web"
          ? { cachePolicy: "memory-disk" as const }
          : {})}
      />
    </View>
    <Button
      variant="tertiary"
      size="md"
      iconName="downloadSimple"
      iconSize="lg"
      color="CTA2"
      iconColor="CTA2"
      iconAlignment="end"
      onClick={onDownloadQr}
      disabled={downloadDisabled}
    >
      Download
    </Button>
  </View>
);
